<template>
  <customer-list :role="USER_ROLES.STORE_MANAGER" />
</template>
<script>
import CustomerList from "@/components/customer/CustomerList.vue";
import { USER_ROLES } from "@/consts";
import normalPage from "@/mixins/normal-page";
export default {
  mixins: [normalPage],
  components: {
    CustomerList,
  },
  data() {
    return {
      USER_ROLES,
    };
  },
};
</script>
<style lang="less" scoped></style>
